import {defineSlotRecipe} from '@chakra-ui/react3'
import {infoTooltipSizes, infoTooltipStyles} from './info-tooltip-styles'

const {closeTrigger, header, body, ...sharedTooltipStyles} = infoTooltipStyles

export const hoverCardSlotRecipe = defineSlotRecipe({
    className: 'chakra-hover-card',
    slots: ['arrow', 'arrowTip', 'trigger', 'positioner', 'content'],
    base: {
        ...sharedTooltipStyles,
        content: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 'popover',
            transformOrigin: 'var(--transform-origin)',
            outline: '0',
            _open: {
                animationStyle: 'slide-fade-in',
                animationDuration: 'fast'
            },
            _closed: {
                animationStyle: 'slide-fade-out',
                animationDuration: 'faster'
            },
            ...infoTooltipStyles.content,
            '& [data-part="close-trigger"]': closeTrigger,
            '& [data-part="header"]': header,
            '& [data-part="body"]': body
        }
    },
    variants: {
        triggerMode: {
            responsive: {
                trigger: {
                    display: 'none',
                    '@media (hover: hover) and (pointer: fine)': {display: 'inline-flex'}
                }
            }
        },
        variant: {
            promoPopover: {
                positioner: {boxShadow: '0px 1px 12px rgba(0, 0, 0, 0.25)'},
                content: {
                    '--info-tooltip-bg': 'colors.white',
                    paddingBlock: '2',
                    paddingInline: '3',
                    border: '1px solid transparent',
                    borderRadius: 'md',
                    boxShadow: 'sm',
                    fontSize: 'md'
                }
            }
        },
        size: infoTooltipSizes
    },
    defaultVariants: {
        size: 'full'
    }
})
